import React from "react";
import {ReceiptsUIProvider} from "../components/ReceiptsUIContext";
import {ReceiptsLoadingDialog} from "../components/receipts-loading-dialog/ReceiptsLoadingDialog";
import {ReceiptsCard} from './ReceiptsCard';

export function ReceiptsPage() {
  const receiptsUIEvents = {};

  return (
    <ReceiptsUIProvider receiptsUIEvents={receiptsUIEvents}>
      <ReceiptsLoadingDialog />
      <ReceiptsCard/>
    </ReceiptsUIProvider>
  );
}
